/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_Not_In_SchoolInputs */

const en_onboarding_education_not_in_school = /** @type {(inputs: Onboarding_Education_Not_In_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in school (professional, personal)`)
};

const es_onboarding_education_not_in_school = /** @type {(inputs: Onboarding_Education_Not_In_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No estoy estudiando (profesional, personal)`)
};

/**
* | output |
* | --- |
* | "Not in school (professional, personal)" |
*
* @param {Onboarding_Education_Not_In_SchoolInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_not_in_school = /** @type {((inputs?: Onboarding_Education_Not_In_SchoolInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_Not_In_SchoolInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_not_in_school(inputs)
	return en_onboarding_education_not_in_school(inputs)
});